<div class="retry-overlay">
    <div class="retry-overlay-content">
        <h4 class="retry-title">
            Applying changes<span class="retry-dots"><span>.</span><span>.</span><span>.</span></span>
        </h4>
        <p class="retry-message">
            Applied changes may take a moment to appear
        </p>
        <p class="retry-submessage">
            <mat-icon class="retry-icon">schedule</mat-icon>
            Please wait while we sync with Microsoft Entra ID
        </p>
    </div>
</div>
